var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "invest-progress-bar" }, [
    _c("div", { staticClass: "invest-progress-bar__details" }, [
      _c("span", { staticClass: "invest-progress-bar__detail" }, [
        _vm._v("Buy\n      "),
        _c("span", { staticClass: "invest-progress-bar__detail-value" }, [
          _vm._v(_vm._s(_vm.i18n.c(_vm.sale.baseHardCap)))
        ]),
        _vm._v("\n      " + _vm._s(_vm.sale.baseAsset) + " for\n      "),
        _c("span", { staticClass: "invest-progress-bar__detail-value" }, [
          _vm._v(_vm._s(_vm.i18n.c(_vm.sale.hardCap)))
        ]),
        _vm._v("\n      " + _vm._s(_vm.sale.defaultQuoteAsset) + "\n      ")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "invest-progress-bar__container" }, [
      _c("div", {
        staticClass: "invest-progress-bar__progress",
        style: "width: " + _vm.progress + "%"
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "invest-progress-bar__details" }, [
      _c("span", { staticClass: "invest-progress-bar__detail" }, [
        _c("span", { staticClass: "invest-progress-bar__detail-value" }, [
          _vm._v(
            _vm._s(_vm.i18n.n(_vm.sale.currentCap)) +
              " " +
              _vm._s(_vm.sale.defaultQuoteAsset)
          )
        ]),
        _vm._v("\n       invested\n    ")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "invest-progress-bar__detail" }, [
        _c("span", { staticClass: "invest-progress-bar__detail-value" }, [
          _vm._v(_vm._s(_vm.daysLeft))
        ]),
        _vm._v("\n      days to go\n    ")
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d348d21", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d348d21","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/sales/to_delete/Sales.ProgressBar.vue
// module id = rVSq
// module chunks = 1